const envConfig = {
  "NODE_ENV": process.env.NODE_ENV,
  "ENV": process.env.ENV,
  "STOREFRONT_CSS": process.env.STOREFRONT_CSS,
  "API_SERVER_HOST": process.env.API_SERVER_HOST,
  "ECWID_API_URL": process.env.ECWID_API_URL,
  "PRIVATE_ECWID_API_URL": process.env.PRIVATE_ECWID_API_URL,
  "SENTRY_DSN": process.env.SENTRY_DSN,
  "SENTRY_ENV": process.env.SENTRY_ENV,
  "VERSION": process.env.VERSION,
  "ECWID_APP_ID": process.env.ECWID_APP_ID
}

export default envConfig;
